import { useState, useEffect, useContext, useRef } from "react";
import { schedulerConfiguration } from "../../../api/automation/automation_schedule_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { DatePicker, Stack, StackItem, TimePicker, getBackgroundShade } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Option, Image, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Dropdown, Input, MessageBar, MessageBarBody, MessageBarTitle, Link, MessageBarActions, Checkbox, ToggleButton, Textarea, Card, useId, Tooltip, Spinner } from "@fluentui/react-components";
import { BookTemplate20Regular, ChatMultipleHeart20Regular, CalendarClock20Regular, Wand20Regular, SettingsCogMultiple20Regular, Filter20Filled, Delete20Regular, Desktop20Filled, ArrowMaximize20Regular, DismissSquare24Filled, AddSquare20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, AddSquare20Regular, FilterDismiss20Filled, Open20Regular, Info24Filled, Info20Filled, Dismiss16Regular, CheckmarkLock20Regular, AlertBadge20Regular, BrainCircuit20Regular, Info16Filled } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { Resize } from "../../../components/textarea/textarea.component";
import { Checked } from "../../../components/switch/switch.component";
import { Inputs } from "../../../components/textarea/input.component";
import { RadioGroups } from "../../../components/radio_group/radioGroup.component";
import { CheckBox } from "../../../components/checkbox/checkbox_component";
import { ToastComponent } from "../../../components/toast/toast.component";
import DialogBox from "../../../components/dialog/dialog.component";
import { MultiselectWithTags } from "../../../components/dropdown/multiselect.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import type { DropdownProps } from "@fluentui/react-components";
import { fullscreenIcon, primaryIcon, secondaryIcon, messageTheme, exitIcon, deleteIcon, lightTheme, overflowDivider, buttonContent, dropdownDataStyle, parentHome, DynamicBoxingCSS, SubSectionResponsive, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { AutomationPages } from "../../../components/side_menu/InlineSidenav";

const handleExportCSV = () => {
  // Programmatically trigger the CSV export link
  const csvExportLink = document.getElementById('csv-export-link');
  if (csvExportLink) {
    csvExportLink.click();
  }
};

export const AutomationSchedule = (props: Partial<DropdownProps>) => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  var dartNo: number = contextValue.dartNo;
  const tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / '); const dropdownId = useId("dropdown-default");
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [overlayName, setOverlayName] = useState('');
  const [searchVal, setSearchVal] = useState("");
  const [isFilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [automationSearchVal, setAutomationSearchVal] = useState("");
  const [automationSearchData, setAutomationSearchData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [buttonStates, setButtonStates] = useState({});
  const [isdeletedisabled, setDeleteDisabled] = useState(true);
  const [isRefresh, setRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
  const [saveTriggered, setSaveTriggered]: any = useState(false);
  const [deleteAutomation, setDeleteAutomation]: any = useState(false);
  const [rowID, setRowID]: any = useState(null);
  const [cloneDailyForms, setcloneDailyForms] = useState<FormDailyItem[]>([]);
  const [formData, setFormData]: any = useState({
    name: '',
    description: '',
    jsonData: {
      type: ''
    }
  });
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [errorToast, setErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [classificationNameValidation, setClassificationNameValidation]: any = useState(true);
  const [selectedAutomation, setSelectedAutomation] = useState('');
  const [automationStatus, setAutomationStatus] = useState('not attached');
  const [loading, setLoading] = useState(true);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  // const [permissions, setPermissions] = useState(['']);
  const { permissions } = usePermissionStore();
  const handle = useFullScreenHandle();
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);

  const [formEditedData, setFormEditedData]: any = useState({
    name: '',
    description: '',
    jsonData: ''
  });
  const [configFormData, setConfigFormData]: any = useState({
    executionTime: []
  });
  const [dartSpecs, setDartSpecs]: any = useState([]);
  const [automationOverLayData, setAutomationOverLayData]: any = useState({});
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const [weekendChecked, setWeekendChecked] = useState(false);
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const dates = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [isCreatedBy, setCreatedBy] = useState<any[]>([]);

  const [disableConfirmBtn, setDisableConfirmBtn] = useState(false);

  useEffect(() => {
    // Direct, simple filtering
    const matchingData = final_data?.filter(
      item => 
        contextValue?.selectedRowIdInTable.includes(item.id) && 
        item.status !== "not attached"
    ) || [];
  
    // Set disable state based on matching data
    setDisableConfirmBtn(matchingData.length > 0);
  }, [contextValue?.selectedRowIdInTable]);
  
  useEffect(() => {
    const createdByOptions = uniqueCreatedBy.map((item) => {
      return { key: item, label: <Caption1>{item}</Caption1>, };
    });
    setCreatedBy(createdByOptions);
    console.log("Created By Options:", createdByOptions);
  }, [uniqueCreatedBy]);

  const handleOptionChange = (value: any) => {
    var optionValue = value.target.value;
    setConfigFormData({
      executionTime: []
    });
    setSelectedOption(optionValue);
  }
  useEffect(() => {
    if (overlayOpen) {
      const element = document.getElementById("fluent-default-layer-host");
      if (element) {
        element.style.zIndex = '9999999';
      }
    }
  }, [overlayOpen])

  const [isIconEnabled, setIconEnabled] = useState(false);
  const handleIconActive: any = (data: any) => {
    setIconEnabled(data.target.checked);
  }
  const [showAdditionalContent, setShowAdditionalContent] = useState(true);

  useEffect(() => {
    var flag = true;
    exportDetails.map((val: any) => {
      if (val.automationName === formData.name || (overlayName == 'editAutomation' && val.automationName === formEditedData.name)) {
        flag = false;
      }
    });

    if (overlayName == 'editAutomation' && formEditedData.name === selectedAutomation) {
      flag = true;
    }

    setClassificationNameValidation(flag);
  }, [formData, formEditedData, selectedAutomation]);

  useEffect(() => {
    if (saveBtnClicked) {
      var tempJsonData: any = {};
      var tempTimeArr: any = configFormData?.executionTime?.map((val: any) => val.time);
      var tempDateArr: any = configFormData?.date?.map((val: any) => val.date);

      console.log("configFormData?.executionTime=", configFormData?.executionTime);
      console.log("month arr=", configFormData?.months);

      tempJsonData = selectedOption == 'daily' ? { type: selectedOption, scheduledAutomations: selectedOptions, executionTime: tempTimeArr, weekend: configFormData.weekend, recommendedAction: configFormData.recommendedAction } :
        selectedOption == 'weekly' ? { type: selectedOption, scheduledAutomations: selectedOptions, executionTime: tempTimeArr, days: configFormData.days, recommendedAction: configFormData.recommendedAction } :
          { type: selectedOption, scheduledAutomations: selectedOptions, months: configFormData?.months, date: tempDateArr, executionTime: tempTimeArr, weekend: configFormData.weekend, recommendedAction: configFormData.recommendedAction }

      setFormData({ ...formData, jsonData: tempJsonData });
      setSaveTriggered(true);
      setAutomationSearchVal("");
    } else {
      setSaveTriggered(false);
      setFormData({ name: '', description: '', jsonData: { type: '' } });
    }
  }, [saveBtnClicked]);

  useEffect(() => {
    console.log("edited formData=", formData);

    if (formData?.name !== '' && overlayName === 'editAutomation') {
      var type = formData.jsonData.type;
      setSelectedOption(type);
      setSelectedOptions(formData.jsonData.scheduledAutomations);

      var timeArr: any = [];
      if (type === 'daily') {
        formData.jsonData?.executionTime?.map((val: any, i: any) => {
          i == 0 ? timeArr.push({ id: 0, time: val }) : timeArr.push({ id: Date.now(), time: val });
        })

        setConfigFormData({
          executionTime: timeArr,
          recommendedAction: formData.jsonData.recommendedAction,
          weekend: formData.jsonData.weekend
        });

        formData?.jsonData?.executionTime?.map((val: any, i: any) => {
          i != 0 && setcloneDailyForms([...cloneDailyForms, { id: Date.now(), data: {} }]);
        });

        setClickedDays(daysOfWeek.reduce((acc, day) => {
          acc = false;
          return acc;
        }, {}));

        setClickedMonths(months.reduce((acc, month) => {
          acc = false;
          return acc;
        }, {}));
      } else if (type == 'weekly') {
        formData.jsonData?.executionTime?.map((val: any, i: any) => {
          i == 0 ? timeArr.push({ id: 0, time: val }) : timeArr.push({ id: Date.now(), time: val });
        })

        setConfigFormData({
          executionTime: timeArr,
          recommendedAction: formData.jsonData.recommendedAction,
          days: formData.jsonData.days
        });

        formData?.jsonData?.days?.map((val: any, i: any) => {
          setClickedDays((prevClickedDays) => ({
            ...prevClickedDays,
            [`isWeeklyButton${val}Clicked`]: !prevClickedDays[`isWeeklyButton${val}Clicked`],
          }));
        });

        formData?.jsonData?.executionTime?.map((val: any, i: any) => {
          i != 0 && setCloneWeeklyForms([...cloneDailyForms, { id: Date.now(), data: {} }]);
        });

        setcloneDailyForms([]);

        setClickedMonths(months.reduce((acc, month) => {
          acc = false;
          return acc;
        }, {}));
      } else {
        //monthly scheduler
        formData?.jsonData?.executionTime?.map((val: any, i: any) => {
          i == 0 ? timeArr.push({ id: 0, time: val }) : timeArr.push({ id: Date.now(), time: val });
        });

        var dateArr: any = [];
        formData?.jsonData?.date?.map((val: any, i: any) => {
          i == 0 ? dateArr.push({ id: 0, date: val }) : dateArr.push({ id: Date.now(), date: val });
        });

        formData?.jsonData?.months?.map((val: any) => {
          setClickedMonths((prevClickedMonths) => ({
            ...prevClickedMonths,
            [`isMonthButton${val}Clicked`]: !prevClickedMonths[`isMonthButton${val}Clicked`],
          }));
        })

        formData?.jsonData?.date?.map((val: any, i: any) => {
          i !== 0 && setcloneMonthlyFormsDate([...cloneMonthlyFormsDate, { id: Date.now(), data: {} }]);
        })

        setcloneDailyForms([]);

        setClickedDays(daysOfWeek.reduce((acc, day) => {
          acc = false;
          return acc;
        }, {}));

        setConfigFormData({
          executionTime: timeArr,
          recommendedAction: formData.jsonData.recommendedAction,
          date: dateArr,
          months: formData.jsonData.months
        });
      }
    }
  }, [formData]);

  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [dropDownValue3, setDropDownValue3] = useState<any>();
  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    // Check if the column is already filtered
    const columnExists = filterArray.some(filter => filter.startsWith(`${value1} :`));
    if (!columnExists) {
      const result = value1 + " : " + value2;
      setFilterArray([...filterArray, result]);
      setIsFilter(true);
      setLoading(true);
      setDropDownValue1('');
      setDropDownValue2('');
    }
  };
  const handleCloseFilter = (index: any): any => {
    console.log("cllciked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
  }
  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    }
    else {
      setResetDisabled(true)
    }
  }, [filterArray])

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_ -]*$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1 === ("Name") || dropDownValue1 === ("Description") || dropDownValue1 === ("Status")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    // if (name === 'filter' && dropDownValue1 === ("Created By")) {
    //   if(regexS.test(enteredValue)){
    //     setDropDownValue2(enteredValue);
    //     }
    // }
  }

  // weekly buttons starts here
  const [clickedDays, setClickedDays] = useState<{ [key: string]: boolean }>(daysOfWeek.reduce((acc, day) => {
    acc = false;
    return acc;
  }, {}));

  var daysArr: any = [];
  const handleWeeklyButtonClick = (day: string) => {
    setClickedDays((prevClickedDays) => ({
      ...prevClickedDays,
      [`isWeeklyButton${day}Clicked`]: !prevClickedDays[`isWeeklyButton${day}Clicked`],
    }));

    daysArr = configFormData?.days?.length > 0 ? configFormData?.days : [];

    if (daysArr.includes(day)) {
      daysArr = daysArr.filter((val: any) => val != day)
    } else {
      daysArr.push(day);
    }

    setConfigFormData({ ...configFormData, days: daysArr });
  };
  // weekly buttons starts here

  const [clickedMonths, setClickedMonths] = useState<{ [key: string]: boolean }>(months.reduce((acc, month) => {
    acc = false;
    return acc;
  }, {}));

  var monthArr: any = [];
  const handleMonthButtonClick = (month: string) => {
    setClickedMonths((prevClickedMonths) => ({
      ...prevClickedMonths,
      [`isMonthButton${month}Clicked`]: !prevClickedMonths[`isMonthButton${month}Clicked`],
    }));

    monthArr = configFormData?.months?.length > 0 ? configFormData?.months : [];

    if (monthArr.includes(month)) {
      monthArr = monthArr.filter((val: any) => val != month)
    } else {
      monthArr.push(month);
    }

    setConfigFormData({ ...configFormData, months: monthArr });
  };

  // Clone daily logic start here
  interface FormDailyItem {
    id: number;
    data: {};
  }
  const handleDailyAddClone = () => {
    if (cloneDailyForms.length < 100) {
      setcloneDailyForms([...cloneDailyForms, { id: Date.now(), data: {} }]);
    }
  };

  const handleRemoveDailyClone = (id: any) => {
    setcloneDailyForms(cloneDailyForms?.filter((formDaily) => formDaily.id !== id));

    var timeArr = configFormData.executionTime?.filter((val: any) => val.id !== id);
    setConfigFormData({ ...configFormData, executionTime: timeArr });
  };
  // clone daily logic ends here

  // clone weekly logic start here
  interface FormWeeklyItem {
    id: number;
    data: {};
  }
  const [cloneWeeklyForms, setCloneWeeklyForms] = useState<FormWeeklyItem[]>([]);
  const handleWeeklyAddClone = () => {
    if (cloneWeeklyForms.length < 100) {
      setCloneWeeklyForms([...cloneWeeklyForms, { id: Date.now(), data: {} }]);
    }
  };
  const handleRemoveWeeklyClone = (id: any) => {
    setCloneWeeklyForms(cloneWeeklyForms.filter((formWeekly) => formWeekly.id !== id));
  };
  // clone weekly logic ends here

  // clone monthly logic start here for time
  interface FormMonthlyTimeItem {
    id: number;
    data: {};
  }
  const [cloneMonthlyFormsTime, setcloneMonthlyFormsTime] = useState<FormMonthlyTimeItem[]>([]);
  const handleMonthlyAddClone = () => {
    if (cloneMonthlyFormsTime.length < 100) {
      setcloneMonthlyFormsTime([...cloneMonthlyFormsTime, { id: Date.now(), data: {} }]);
    }
  };
  const handleRemoveMonthlyCloneTime = (id: any) => {
    setcloneMonthlyFormsTime(cloneMonthlyFormsTime.filter((formMonthlyTime) => formMonthlyTime.id !== id));
  };
  // clone monthly logic ends here for time

  // clone monthly logic start here for date
  interface FormMonthlyDateItem {
    id: number;
    data: {};
  }
  const [cloneMonthlyFormsDate, setcloneMonthlyFormsDate] = useState<FormMonthlyDateItem[]>([]);
  const handleMonthlyAddCloneDate = () => {
    if (cloneMonthlyFormsDate.length < 100) {
      setcloneMonthlyFormsDate([...cloneMonthlyFormsDate, { id: Date.now(), data: {} }]);
    }

  };
  const handleRemoveMonthlyCloneDate = (id: any) => {
    setcloneMonthlyFormsDate(cloneMonthlyFormsDate.filter((formMonthlyDate) => formMonthlyDate.id !== id));
  };
  // clone monthly logic ends here for date

  // const handleNewFormChange = (e: any) => {
  //   setFormData({...formData,
  //     jsonData: e.formData
  //   });
  // }

  // const handleEditFormChange = (e: any) => {
  //   setFormEditedData({...formEditedData,
  //     jsonData: e.formData
  //   });
  // }

  const handleDatepicker = (e: any, ids: any) => {
    const formattedDate = e;
    // const formattedDate = parseInt(e.toISOString().split('T')[0].split("-")[2]) + 1;
    console.log("formattedDate=", formattedDate);

    var DateArr: any = configFormData?.date?.length ? configFormData?.date : [];
    var flag = 1;

    DateArr.map((val: any) => {
      if (flag == 1 && val.id == ids) {
        flag = 0;
        val.date = formattedDate.toString();
      }
    });

    flag == 1 && DateArr.push({ id: ids, date: formattedDate.toString() });
    setConfigFormData({ ...configFormData, date: DateArr });
  }


  const handleTimepicker = (e: any, ids: any) => {
    var timeArr: any = configFormData.executionTime.length ? configFormData.executionTime : [];
    console.log("time arr=", timeArr);

    var flag = 1;
    timeArr.map((val: any) => {
      if (flag == 1 && val.id == ids) {
        flag = 0;
        val.time = e;
      }
    })

    flag == 1 && timeArr.push({ id: ids, time: e });
    setConfigFormData({ ...configFormData, executionTime: timeArr });
  }

  const handleWeekendCheckbox = (e: any) => {
    setWeekendChecked(e.target.checked);
    setConfigFormData({ ...configFormData, weekend: e.target.checked });
  }

  const handleRadioGrps = (e: any) => {
    setConfigFormData({ ...configFormData, recommendedAction: e.target.value });
  }
  const handleSubmit = (e: any) => {
    e.preventDefault();
  }
  const buttonref: any = useRef(null);
  const handleOutsideButton = () => {
    buttonref?.current?.click();
  };

  let dayslist: any;
  useEffect(() => {
    console.log("configFormData=", configFormData);
    if (dayslist != undefined) {
      configFormData.days.map((index: any) => {
        dayslist.push(index);
      })
    }
  }, [configFormData]);

  //data table column name code starts here
  // var columns = [
  //   { key: "name", label: <Body1Strong> Name </Body1Strong> },
  //   { key: "description", label: <Body1Strong> Description </Body1Strong> },
  //   { key: "created_by", label: <Body1Strong> Created by </Body1Strong> },
  //   { key: "created_on", label: <Body1Strong> Created On (UTC) </Body1Strong> },
  //   { key: "created_on_timezoned", label: <Body1Strong> Created On ({formattedTimeZone}) </Body1Strong> },
  //   { key: "last_modified", label: <Body1Strong> Last Modified (UTC) </Body1Strong> },
  //   { key: "last_modified_timezoned", label: <Body1Strong> Last Modified ({formattedTimeZone}) </Body1Strong> },
  //   { key: "status", label: <Body1Strong> Status </Body1Strong> },
  // ];

  //filter column starts here
  // var columns1 = [
  //   { key: "name", label: <Caption1> Name </Caption1> },
  //   { key: "description", label: <Caption1> Description </Caption1> },
  //   { key: "created_by", label: <Caption1> Created by </Caption1> },
  //   { key: "created_on", label: <Caption1> Created On </Caption1> },
  //   { key: "last_modified", label: <Caption1> Last Modified </Caption1> },
  //   { key: "status", label: <Caption1> Status </Caption1> },
  // ];
  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.Automation?.Scheduler.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "created_on_timezoned" || val.key === "last_modified_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Automation?.Scheduler.filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "Automation", page: "Scheduler" });
  }, [contextValue.tableColumnsData]);

  const radioData = {
    "Daily": "daily",
    "Weekly": "weekly",
    "Monthly": "monthly"
  };
  const radioData1 = {
    "Execute earliest available opportunity": "1",
    "Execute next available schedule ": "2",
  };

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        {/* <Stack tokens={{childrenGap:10}} horizontal> */}
        {permissions.includes("all") || permissions.includes("automationSchedule_Fullaccess") ?
          <StackItem onClick={() => { setSelectedOptions([]); setOverlayOpen(true); setOverlayName('addAutomation'); setAutomationStatus('not attached'); setFormData({ name: '', description: '', jsonData: { type: '' } }); setConfigFormData({ executionTime: [] }); }}>
            <Button shape="circular" disabled={loading} appearance="subtle" size="small">
              <StackItem>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem>
                    {loading ?
                      <AddSquare20Regular {...secondaryIcon} />
                      : <AddSquare20Regular {...primaryIcon} />}</StackItem>
                  <StackItem> <Caption1> Create Automation Scheduler </Caption1> </StackItem>
                </Stack>
              </StackItem>
            </Button>
          </StackItem>
          :
          <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
            <Button shape="circular" appearance="subtle" size="small" disabled>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem><Text></Text></StackItem>
                <StackItem>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                    <StackItem><Caption1> Create Automation Scheduler </Caption1></StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </Button>
          </Tooltip>
        }

        <StackItem>
          <Divider vertical />
        </StackItem>

        <StackItem>
          <DialogBox
            headerButton={
              <>
                <Button shape="circular" appearance="transparent" size="small"
                  disabled={isdeletedisabled ? true : false} >
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>
                      {/* <Delete20Regular {...primaryIcon} />  */}
                      {isdeletedisabled
                        ? (<Delete20Regular {...secondaryIcon} />)
                        : (<Delete20Regular {...primaryIcon} />)
                      }

                    </StackItem>
                    <StackItem> <Caption1> Delete </Caption1> </StackItem>
                  </Stack>
                </Button>
              </>
            }

            content={disableConfirmBtn ? "Enabled automation cannot be deleted. Please disable or unselect the enabled automation and try again." : "Please confirm if you want to proceed with deleting the automation."}

            footer=
            {
              <>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                  <StackItem>
                    <Button shape="circular" disabled={disableConfirmBtn} appearance="primary" onClick={() => { setDeleteAutomation(true); /*userActivity('Delete', `{"summary":"${contextValue.selectedRowIdInTable.length} scheduled automations deleted"}`);*/ }} size="small">Confirm</Button>
                  </StackItem>
                  <StackItem>
                    <Button shape="circular" size="small">Cancel</Button>
                  </StackItem>
                </Stack>
              </>
            }
          />
        </StackItem>

        <StackItem>
          <Divider vertical />
        </StackItem>

        {/* <Stack tokens={{childrenGap:6}}> */}
        {/* <StackItem><Text></Text></StackItem> */}
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setRefresh(true); setCurrentPageNo(1); setLoading(true); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>

          {permissions.includes("all") || permissions.includes("automationSchedule_Fullaccess") || permissions.includes("automationSchedule_ReadandExport") ?
            <>
              <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_scheduled_automations.csv`}>
              </CSVLink>
              <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); /*userActivity('Export', `{"summary":"scheduled automation list exported"}`);*/ }}>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                  <StackItem> <Caption1> Export </Caption1> </StackItem>
                </Stack>
              </Button>
            </>
            :
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem><Text></Text></StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem><Caption1> Export </Caption1></StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>}

          {/* <StackItem> */}
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
          {/* </StackItem> */}
        </StackItem>
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
        {/* </Stack>
        </Stack> */}
      </>,
  };

  useEffect(() => {
    if (dartSpecs?.length > 0 || automationSearchData?.length > 0 || selectedOptions?.length > 0) {
      let details = dartSpecs?.length > 0 ? dartSpecs[0]?.details : "{}";
      details = JSON.parse(details);

      overlayName === 'addAutomation' && setAutomationOverLayData({
        headerTitle: "Create Automation Scheduler",
        size: "large",
        isTabs: true,
        tabItems:
        {
          Introduction:
            <form id="myFormAutomationschedule" onSubmit={(e) => handleSubmit(e)} autoComplete="off">
              <>
                <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                  {/* <StackItem> 
                <FluentProvider theme={messageTheme}>
                  <Card appearance="subtle" size="small">
                    <Stack tokens={{childrenGap:10}} horizontal>
                      <StackItem> <Info24Filled {...primaryIcon}/> </StackItem>
                      <StackItem> <Caption1> These details will make it easy to find the snippets later when you need to use them </Caption1>  </StackItem>
                    </Stack>
                  </Card>
                </FluentProvider>
              </StackItem> */}
                  <StackItem>
                    <Stack>
                      <StackItem> <Body1Strong> Name of the automation schedule <Image src="/Dashboard/image/required.svg" /></Body1Strong> </StackItem>
                      <StackItem>
                        <Inputs inputChange={setFormData} inputVal={formData} required={true} />
                        {!classificationNameValidation && <Body1>This automation name already exists</Body1>}
                      </StackItem>
                    </Stack>
                  </StackItem>
                  <StackItem>
                    <Stack>
                      <StackItem> <Body1Strong> Description </Body1Strong> </StackItem>
                      <StackItem> <Resize inputChange={setFormData} inputValue={formData} /> </StackItem>
                    </Stack>
                  </StackItem>
                  <StackItem>
                    <Stack>
                      <StackItem> <Body1Strong> Search for a self-help/proactive solution that is attached, as the scheduler can only be created for these.<Image src="/Dashboard/image/required.svg" /></Body1Strong> </StackItem>
                      <StackItem>
                        {selectedOptions?.length > 0 && <Badge>{selectedOptions[0]}</Badge>}
                      </StackItem>
                      <StackItem>
                        <MultiselectWithTags onChange={(e: any) => setAutomationSearchVal(e.target.value)} options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={false} tag={false} placeholder="Please Search" required={selectedOptions?.length > 0 ? false : true} />
                      </StackItem>
                      <StackItem></StackItem>
                    </Stack>
                  </StackItem>
                  {showAdditionalContent && (
                    <>
                      <InfoBar title={"These are the basic details associated with this Scheduled Selfhelp."} />

                      {Object.keys(details).map(key => (
                        <>
                          <StackItem>
                            <p><b>{key}</b></p>
                          </StackItem>
                          <StackItem>
                            <p>{details[key]}</p>
                          </StackItem>
                        </>
                      ))}
                    </>
                  )}
                </Stack>
                <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
              </>
              <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
            </form>,

          Configuration:
            <form autoComplete="off" id="myFormAutomationschedule" onSubmit={(e) => handleSubmit(e)}>
              <>
                <Stack>
                  <Stack tokens={{ childrenGap: 10 }}>
                    <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                  </Stack>

                  <StackItem>
                    <RadioGroups data={radioData} layout="horizontal" value={selectedOption} onChange={(e) => handleOptionChange(e)} required={true} />
                  </StackItem>

                  <StackItem>
                    <Stack tokens={{ padding: "10px 0px" }}>
                      <StackItem>
                        <>
                          {
                            (selectedOption == 'daily') &&
                            <Stack tokens={{ childrenGap: 20 }}>
                              <StackItem>
                                <Stack tokens={{ childrenGap: 20 }} horizontal>
                                  <StackItem>
                                    {configFormData.executionTime[0]?.time?.length > 0 ? <div style={dropdownDataStyle}><TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} defaultValue={new Date(`November 25, 2023 ${configFormData.executionTime[0]?.time}:00`)} /></div> : <div style={dropdownDataStyle}><TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} required /></div>}
                                  </StackItem>
                                  <StackItem><Image src="/Dashboard/image/required.svg" /></StackItem>
                                  
                                  <StackItem>
                                    <Stack tokens={{ childrenGap: 5 }}>
                                      <StackItem><Text></Text></StackItem>
                                      <StackItem> <AddSquare20Filled {...primaryIcon} onClick={handleDailyAddClone} /> </StackItem>
                                    </Stack>
                                  </StackItem>
                                  <StackItem>
                                    <Checkbox checked={configFormData.weekend} onChange={handleWeekendCheckbox} label="Include Weekends" />
                                  </StackItem>
                                </Stack>
                              </StackItem>
                              <StackItem>
                                {cloneDailyForms.map((formDaily: any, i: any) => (
                                  <Stack key={formDaily.id}>
                                    <Stack horizontal tokens={{ childrenGap: 480 }}>
                                      <StackItem>
                                        {(selectedOption === 'daily') &&
                                          <Stack horizontal tokens={{ childrenGap: 20 }}>
                                            <Stack tokens={{ childrenGap: 20 }} horizontal>
                                              <StackItem>
                                                {configFormData.executionTime[i + 1]?.time?.length > 0 ? <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, formDaily.id) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, formDaily.id) }} defaultValue={new Date(`November 25, 2023 ${configFormData.executionTime[i + 1]?.time}:00`)} required /> : <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, formDaily.id) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, formDaily.id) }} />}
                                              </StackItem>
                                                <StackItem><Image src="/Dashboard/image/required.svg" /></StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 5 }}>
                                                  <StackItem><Text></Text></StackItem>
                                                  <StackItem> <Delete20Regular {...deleteIcon} onClick={() => handleRemoveDailyClone(formDaily.id)} /> </StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </Stack>
                                        }
                                      </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                  </Stack>
                                ))}
                              </StackItem>
                              <StackItem>
                                <Stack>
                                  <StackItem> <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1> </StackItem>
                                  <StackItem> <Body1> <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" /> </Body1> </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          }
                        </>
                      </StackItem>
                      <StackItem>
                        <>
                          {
                            (selectedOption == 'weekly') &&
                            <Stack tokens={{ childrenGap: 20 }}>
                              <StackItem>
                                <Stack>
                                  <StackItem><Text></Text></StackItem>
                                  <StackItem>
                                    <Stack horizontal tokens={{ childrenGap: 20 }}>
                                      {daysOfWeek.map((day) => (
                                        <StackItem key={day}>
                                          <Button shape="circular" size="medium" appearance={clickedDays[`isWeeklyButton${day}Clicked`] ? 'primary' : 'outline'} onClick={() => handleWeeklyButtonClick(day)}>
                                            {day.substring(0, 3)}
                                          </Button>
                                        </StackItem>
                                      ))}
                                    </Stack>
                                  </StackItem>
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack horizontal>
                                  <StackItem><Text></Text></StackItem>
                                  <StackItem>
                                    <Stack tokens={{ childrenGap: 10 }}>
                                      <Text> At what time should scheduler execute? <Image src="/Dashboard/image/required.svg" /></Text>
                                      <StackItem>
                                        <Stack tokens={{ childrenGap: 20 }} horizontal>
                                          <StackItem>
                                            {configFormData.executionTime[0]?.time?.length > 0 ? <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} defaultValue={new Date(`November 25, 2023 ${configFormData.executionTime[0]?.time}:00`)} required /> : <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} required />}
                                          </StackItem>
                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }}>
                                              <StackItem><Text></Text></StackItem>
                                              <StackItem> <AddSquare20Filled {...primaryIcon} onClick={handleWeeklyAddClone} /> </StackItem>
                                            </Stack>
                                          </StackItem>
                                        </Stack>
                                      </StackItem>
                                    </Stack>
                                  </StackItem>
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack horizontal>
                                  <StackItem><Text></Text></StackItem>
                                  <StackItem>
                                    {cloneWeeklyForms.map((formWeekly: any, i: any) => (
                                      <Stack key={formWeekly.id}>
                                        <Stack horizontal tokens={{ childrenGap: 480 }}>
                                          <StackItem>
                                            {(selectedOption === 'weekly') &&
                                              <Stack horizontal tokens={{ childrenGap: 20 }}>
                                                <Stack tokens={{ childrenGap: 4 }} horizontal>
                                                  <StackItem>
                                                    {configFormData.executionTime[i + 1]?.time?.length > 0 ? <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, formWeekly.id) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, formWeekly.id) }} defaultValue={new Date(`November 25, 2023 ${configFormData.executionTime[i + 1]?.time}:00`)} required /> : <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, formWeekly.id) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, formWeekly.id) }} required />}
                                                    {/* <Image src="/Dashboard/image/required.svg" /> */}
                                                  </StackItem>
                                                  <StackItem><Image src="/Dashboard/image/required.svg" /></StackItem>
                                                  <StackItem>
                                                    <Stack tokens={{ childrenGap: 5 }}>
                                                      <StackItem><Text></Text></StackItem>
                                                      <StackItem> <Delete20Regular {...deleteIcon} onClick={() => handleRemoveWeeklyClone(formWeekly.id)} />  </StackItem>
                                                    </Stack>
                                                  </StackItem>
                                                </Stack>
                                              </Stack>
                                            }
                                          </StackItem>
                                        </Stack>
                                        <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                      </Stack>
                                    ))}
                                  </StackItem>
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack>
                                  <StackItem> <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1> </StackItem>
                                  <StackItem> <Body1> <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" /> </Body1> </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          }
                        </>
                      </StackItem>
                      <StackItem>
                        <>
                          {
                            (selectedOption == 'monthly') &&
                            <Stack tokens={{ childrenGap: 10 }}>
                              <StackItem>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                  {months.slice(0, 6).map((month) => (
                                    <StackItem key={month}>
                                      <Button shape="circular" size="medium" appearance={clickedMonths[`isMonthButton${month}Clicked`] ? 'primary' : 'outline'} onClick={() => handleMonthButtonClick(month)} >
                                        {month}
                                      </Button>
                                    </StackItem>
                                  ))}
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                  {months.slice(6).map((month) => (
                                    <StackItem key={month}>
                                      <Button shape="circular" size="medium" appearance={clickedMonths[`isMonthButton${month}Clicked`] ? 'primary' : 'outline'} onClick={() => handleMonthButtonClick(month)} >
                                        {month}
                                      </Button>
                                    </StackItem>
                                  ))}
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                <Stack>
                                  <StackItem>
                                    <Body1> On which date should the scheduler execute? </Body1>
                                    <StackItem grow>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem grow>
                                          {/* <DatePicker onSelectDate={(e: any) => {handleDatepicker(e,0)}} placeholder="Enter Date Here" defaultValue={configFormData} /> */}

                                          <Dropdown value={configFormData?.date ? configFormData?.date[0]?.date : ''} placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium">
                                            {dates.map((val) =>
                                              <Option key={`op_${val}`} text={val} value={val} onClick={() => { handleDatepicker(parseInt(val), 0) }}>
                                                {val}
                                              </Option>
                                            )}
                                          </Dropdown>
                                        </StackItem>
                                        <Stack tokens={{ childrenGap: 15 }} horizontal>
                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }}>
                                              <StackItem><Text></Text></StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 15 }} horizontal>
                                                  <StackItem><Text></Text></StackItem>
                                                  <StackItem> <AddSquare20Regular {...primaryIcon} onClick={handleMonthlyAddCloneDate} /> </StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                        </Stack>
                                      </Stack>
                                    </StackItem>
                                  </StackItem>
                                </Stack>
                                {/* WRITE MONTHLY CLONE DATE STARTS HERE */}
                                <StackItem>
                                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                                    <StackItem>
                                      <Text>&nbsp;</Text>
                                    </StackItem>
                                  </Stack>
                                  {cloneMonthlyFormsDate.map((formMonthlyDate: any, i: any) => (
                                    <Stack key={formMonthlyDate.id}>
                                      <Stack horizontal tokens={{ childrenGap: 480 }}>
                                        <StackItem grow>
                                          {(selectedOption === 'monthly') &&
                                            <Stack horizontal tokens={{ childrenGap: 20 }}>
                                              <Stack tokens={{ childrenGap: 20 }} horizontal>
                                                <StackItem grow>
                                                  {/* <DatePicker onSelectDate={(e: any) => {handleDatepicker(e,formMonthlyDate.id)}} onKeyUp={(e: any) => {handleDatepicker(e,formMonthlyDate.id)}} placeholder = "Enter Date Here......................." /> */}
                                                  <Dropdown value={configFormData?.date ? configFormData?.date[i + 1]?.date : ''} placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium" aria-required>
                                                    {dates.map((val) =>
                                                      <Option key={`op_${val}`} text={val} value={val} onClick={() => { handleDatepicker(parseInt(val), formMonthlyDate.id) }}>
                                                        {val}
                                                      </Option>
                                                    )}
                                                  </Dropdown>
                                                  <Image src="/Dashboard/image/required.svg" />
                                                </StackItem>
                                                <StackItem>
                                                  <Stack tokens={{ childrenGap: 5 }}>
                                                    <StackItem><Text></Text></StackItem>
                                                    <StackItem> <Delete20Regular {...deleteIcon} onClick={() => handleRemoveMonthlyCloneDate(formMonthlyDate.id)} /> </StackItem>
                                                  </Stack>
                                                </StackItem>
                                              </Stack>
                                            </Stack>
                                          }
                                        </StackItem>
                                      </Stack>
                                      <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                    </Stack>
                                  ))}
                                </StackItem>
                                {/* WRITE MONTHLY CLONE DATE ENDS HERE */}
                                <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                <Stack>
                                  <StackItem>
                                    <Body1> At what time should the scheduler execute?<Image src="/Dashboard/image/required.svg" /> </Body1>
                                    <StackItem grow>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem grow>
                                          {configFormData.executionTime[0]?.time?.length > 0 ? <TimePicker required placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} defaultValue={new Date(`November 25, 2023 ${configFormData.executionTime[0]?.time}:00`)} /> : <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} required />}
                                        </StackItem>
                                          <Stack tokens={{ childrenGap: 307 }} horizontal>
                                            <StackItem>
                                              <Stack tokens={{ childrenGap: 5 }}>
                                                <StackItem><Text></Text></StackItem>
                                                <StackItem>
                                                  <Stack tokens={{ childrenGap: 15 }} horizontal>
                                                    <StackItem><Text></Text></StackItem>
                                                    <StackItem> <AddSquare20Filled {...primaryIcon} onClick={handleMonthlyAddClone} /> </StackItem>
                                                  </Stack>
                                                </StackItem>
                                              </Stack>
                                            </StackItem>
                                            <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                          </Stack>
                                      </Stack>
                                    </StackItem>
                                  </StackItem>
                                </Stack>
                              </StackItem>
                              {/* WRITE MONTHLY CLONE TIME STARTS HERE */}
                              <StackItem>
                                {cloneMonthlyFormsTime.map((formMonthlyTime) => (
                                  <Stack key={formMonthlyTime.id}>
                                    <Stack horizontal tokens={{ childrenGap: 480 }}>
                                      <StackItem grow>
                                        {(selectedOption === 'monthly') &&
                                          <Stack horizontal tokens={{ childrenGap: 20 }}>
                                            <Stack tokens={{ childrenGap: 20 }} horizontal>
                                              <StackItem>
                                                <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, formMonthlyTime.id) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, formMonthlyTime.id) }} />
                                              </StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 5 }}>
                                                  <StackItem><Text></Text></StackItem>
                                                  <StackItem> <Delete20Regular {...deleteIcon} onClick={() => handleRemoveMonthlyCloneTime(formMonthlyTime.id)} /> </StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </Stack>
                                        }
                                      </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                  </Stack>
                                ))}
                              </StackItem>
                              {/* WRITE MONTHLY CLONE TIME ENDS HERE */}
                              <StackItem>
                                <Stack>
                                  <StackItem> <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1> </StackItem>
                                  <StackItem> <Body1> <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" /> </Body1> </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          }
                        </>
                      </StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </>
              <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
            </form>,

          "Review Data":
            <>
              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong> Name of the automation schedule </Body1Strong> </StackItem>
                    <StackItem> <Inputs inputChange={setFormData} inputVal={formData} disabled={true} /> </StackItem>
                  </Stack>
                </StackItem>

                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong> Description </Body1Strong> </StackItem>
                    <StackItem> <Resize inputChange={setFormData} inputValue={formData} disabled={true} /> </StackItem>
                  </Stack>
                </StackItem>

                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong>Automation that you Scheduled Selfhelp</Body1Strong> </StackItem>
                    <StackItem>
                      {selectedOptions?.length > 0 && <Badge color="informative">{selectedOptions[0]}</Badge>}
                    </StackItem>
                  </Stack>
                </StackItem>

                <StackItem>
                  <Stack tokens={{ padding: 10 }}>
                    <StackItem>
                      <>
                        {
                          (selectedOption == 'daily') &&
                          <Stack tokens={{ childrenGap: 5 }}>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 3 }}>
                                <StackItem>
                                  <Body1Strong>
                                    At what time should the scheduler execute?
                                  </Body1Strong>
                                </StackItem>
                                <StackItem>
                                  * This Schedule to be exuted at {configFormData?.executionTime[0]?.time} {configFormData.weekend == true && "on weekends"}
                                </StackItem>
                                <StackItem>
                                  {/* <Checkbox checked={configFormData.weekend} onChange={handleWeekendCheckbox} label="Include Weekends" disabled={true} />  */}
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              {/* {cloneDailyForms.map((formDaily: any, i: any) => (
                              <Stack key={formDaily.id}>
                                <Stack horizontal tokens={{childrenGap:480}}>
                                  <StackItem>
                                    {(selectedOption ==='daily') && 
                                    <Stack horizontal tokens={{childrenGap:20}}>
                                      <Stack tokens={{childrenGap:25}} horizontal>
                                        <StackItem> 
                                          <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[i+1]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                          </Dropdown>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                    }
                                  </StackItem>
                                </Stack>
                                <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                              </Stack>
                            ))} */}
                            </StackItem>
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Body1Strong>
                                    In the case of a missed schedule, what is the the recommended course of action?
                                  </Body1Strong>
                                </StackItem>
                                <StackItem>
                                  * {configFormData.recommendedAction == 1 ? "Execute earliest available opportunity" : "Execute next available schedule "}
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        }
                      </>
                    </StackItem>
                    <StackItem>
                      <>
                        {
                          (selectedOption == 'weekly') &&
                          <Stack tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <Stack>
                                <StackItem><Text></Text></StackItem>
                                {/* <StackItem> 
                                <Stack horizontal tokens={{childrenGap:20}}>
                                  {daysOfWeek.map((day) => (
                                    <StackItem key={day}>
                                      <Button shape="circular" disabled={true} size="medium" appearance={clickedDays[`isWeeklyButton${day}Clicked`] ? 'primary' : 'outline'} onClick={() => handleWeeklyButtonClick(day)}>
                                        {day.substring(0, 3)}
                                      </Button>
                                    </StackItem>
                                  ))}
                                </Stack>
                              </StackItem> */}
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack horizontal>
                                <StackItem><Text></Text></StackItem>
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 5 }}>
                                    <Body1Strong> At what time should scheduler execute?</Body1Strong>
                                    <StackItem>
                                      <StackItem>
                                        <StackItem>
                                          * This Schedule to be exuted at {configFormData?.executionTime[0]?.time} {configFormData.weekend == true && "on weekends"} on {configFormData?.days?.map((i: any) => i).join(",")}
                                        </StackItem>
                                      </StackItem>
                                    </StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 5 }} horizontal>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Body1Strong> In the case of a missed schedule, what is the the recommended course of action? </Body1Strong>
                                </StackItem>
                                <StackItem>
                                  <Body1>
                                    * {configFormData.recommendedAction == 1 ? "Execute earliest available opportunity" : "Execute next available schedule "}
                                  </Body1>
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        }
                      </>
                    </StackItem>
                    <StackItem>
                      <>
                        {
                          (selectedOption == 'monthly') &&
                          <Stack tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              {/* <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack> */}
                              <Stack>
                                <StackItem>
                                  <Body1Strong> On which date should the scheduler execute? </Body1Strong>
                                  <StackItem grow>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem grow>
                                        {/* <Dropdown value={configFormData?.date ? configFormData?.date[0]?.date : ''}placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                                      </Dropdown> */}
                                        <StackItem>
                                          * This Schedule to be exuted at {configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} on {configFormData?.date ? configFormData?.date[0]?.date : ''}th of {configFormData?.months?.map((i: any) => i).join(",")} {/* on {configFormData.weekend == true && "on weekends"}*/}
                                        </StackItem>
                                      </StackItem>
                                    </Stack>
                                  </StackItem>
                                </StackItem>
                              </Stack>
                              {/* WRITE MONTHLY CLONE DATE STARTS HERE */}
                              <StackItem>
                                <Stack horizontal tokens={{ childrenGap: 20 }}>
                                  <StackItem>
                                    {/* <Text>&nbsp;</Text> */}
                                  </StackItem>
                                </Stack>
                                {cloneMonthlyFormsDate.map((formMonthlyDate: any, i: any) => (
                                  <Stack key={formMonthlyDate.id}>
                                    <Stack horizontal tokens={{ childrenGap: 480 }}>
                                      <StackItem grow>
                                        {(selectedOption === 'monthly') &&
                                          <Stack horizontal tokens={{ childrenGap: 20 }}>
                                            <Stack tokens={{ childrenGap: 20 }} horizontal>
                                              <StackItem grow>
                                                * This Schedule to be exuted at {configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} on {configFormData?.date ? configFormData?.date[i + 1]?.date : ''}th of {configFormData?.months?.map((i: any) => i).join(",")} {/* on {configFormData.weekend == true && "on weekends"}*/}
                                              </StackItem>
                                            </Stack>
                                          </Stack>
                                        }
                                      </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                  </Stack>
                                ))}
                              </StackItem>
                              {/* WRITE MONTHLY CLONE DATE ENDS HERE */}
                              {/* <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack> */}
                              <Stack>
                                {/* <StackItem> 
                                <Body1Strong> At what time should the scheduler execute? </Body1Strong>
                                <StackItem grow>  
                                  <Stack tokens={{childrenGap:5}} horizontal>
                                    <StackItem grow> 
                                      <StackItem>
                                      * This Schedule to be exuted at {configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''}
                                      </StackItem>
                                    </StackItem>
                                  </Stack>
                                </StackItem>
                              </StackItem> */}
                              </Stack>
                            </StackItem>
                            {/* WRITE MONTHLY CLONE TIME STARTS HERE */}
                            <StackItem>
                              {cloneMonthlyFormsTime.map((formMonthlyTime) => (
                                <Stack key={formMonthlyTime.id}>
                                  <Stack horizontal tokens={{ childrenGap: 480 }}>
                                    <StackItem>
                                      {(selectedOption === 'monthly') &&
                                        <Stack horizontal tokens={{ childrenGap: 20 }}>
                                          <Stack tokens={{ childrenGap: 20 }} horizontal>
                                            <StackItem>
                                              *3{configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} on {configFormData?.months} on {configFormData.weekend == true && "on weekends"}
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                      }
                                    </StackItem>
                                  </Stack>
                                  <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                </Stack>
                              ))}
                            </StackItem>
                            {/* WRITE MONTHLY CLONE TIME ENDS HERE */}
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Body1Strong> In the case of a missed schedule, what is the the recommended course of action? </Body1Strong>
                                </StackItem>
                                <StackItem>
                                  * {configFormData.recommendedAction == 1 ? "Execute earliest available opportunity" : "Execute next available schedule "}
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        }
                      </>
                    </StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </>,
        },
      });

      console.log("automationStatus-->", automationStatus);

      overlayName === 'editAutomation' && automationStatus === 'not attached' && setAutomationOverLayData({
        headerTitle: `Edit ${selectedAutomation}`,
        size: "large",
        isTabs: true,
        tabItems:
        {
          Introduction:spinnerLoad?
          <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner/>
          </Stack>:
            <form autoComplete="off" id="myFormAutomationschedule" onSubmit={(e) => handleSubmit(e)}>  <>
              <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                <InfoBar title={"These details will make it easy to find the snippets later when you need to use them."} />
                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong> Name of the automation schedule <Image src="/Dashboard/image/required.svg" /></Body1Strong> </StackItem>
                    <StackItem>
                      <Inputs inputChange={setFormData} inputVal={formData} required={true} />
                      {!classificationNameValidation && <Body1>This automation name already exists</Body1>}
                    </StackItem>
                  </Stack>
                </StackItem>
                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong> Description </Body1Strong> </StackItem>
                    <StackItem> <Resize inputChange={setFormData} inputValue={formData} /> </StackItem>
                  </Stack>
                </StackItem>
                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong> Search for a self-help/proactive solution that is attached, as the scheduler can only be created for these. <Image src="/Dashboard/image/required.svg" /></Body1Strong> </StackItem>
                    <StackItem>
                      {selectedOptions?.length > 0 && <Badge>{selectedOptions[0]}</Badge>}
                    </StackItem>
                    <StackItem>
                      <MultiselectWithTags onChange={(e: any) => setAutomationSearchVal(e.target.value)} options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={false} tag={false} placeholder="Please Search" required={selectedOptions?.length > 0 ? false : true} />
                    </StackItem>
                    <StackItem></StackItem>
                  </Stack>
                </StackItem>
                {showAdditionalContent && (
                  <>
                    <InfoBar title={"These are the basic details associated with this Scheduled Selfhelp."} />
                    {Object.keys(details).map(key => (
                      <>
                        <StackItem>
                          <p><b>{key}</b></p>
                        </StackItem>
                        <StackItem>
                          <p>{details[key]}</p>
                        </StackItem>
                      </>
                    ))}
                  </>
                )}
              </Stack>
              <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
            </>
              <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
            </form>,

          Configuration:
            <form autoComplete="off" id="myFormAutomationschedule" onSubmit={(e) => handleSubmit(e)}>
              <>
                <Stack>
                  <Stack tokens={{ childrenGap: 10 }}>
                    <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                  <StackItem> <RadioGroups defaultValue={formData.jsonData.type} data={radioData} layout="horizontal" value={selectedOption} onChange={(e) => handleOptionChange(e)} required={true} /> </StackItem>
                  <StackItem>
                    <Stack tokens={{ padding: "10px 0px" }}>
                      <StackItem>
                        <>
                          {
                            (selectedOption == 'daily') &&
                            <Stack tokens={{ childrenGap: 20 }}>
                              <StackItem>
                                <Stack tokens={{ childrenGap: 20 }} horizontal>
                                  <StackItem>
                                    {configFormData.executionTime[0]?.time?.length > 0 ? <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} defaultValue={new Date(`November 25, 2023 ${configFormData.executionTime[0]?.time}:00`)} /> : <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} />}
                                  </StackItem>
                                  <StackItem>
                                    <Checkbox checked={configFormData.weekend} onChange={handleWeekendCheckbox} label="Include Weekends" />
                                  </StackItem>
                                  {/* <StackItem> 
                                <Stack tokens={{childrenGap:5}}>
                                  <StackItem><Text></Text></StackItem>
                                  <StackItem> <AddSquare20Filled {...primaryIcon} onClick={handleDailyAddClone}/> </StackItem>
                                </Stack>
                              </StackItem> */}
                                </Stack>
                              </StackItem>
                              <StackItem>
                                {cloneDailyForms.map((formDaily) => (
                                  <Stack key={formDaily.id}>
                                    <Stack horizontal tokens={{ childrenGap: 480 }}>
                                      <StackItem>
                                        {(selectedOption === 'daily') &&
                                          <Stack horizontal tokens={{ childrenGap: 20 }}>
                                            <Stack tokens={{ childrenGap: 25 }} horizontal>
                                              <StackItem> <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, formDaily.id) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, formDaily.id) }} /> </StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 5 }}>
                                                  <StackItem><Text></Text></StackItem>
                                                  <StackItem> <Delete20Regular {...deleteIcon} onClick={() => handleRemoveDailyClone(formDaily.id)} /> </StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </Stack>
                                        }
                                      </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                  </Stack>
                                ))}
                              </StackItem>
                              <StackItem>
                                <Stack>
                                  <StackItem> <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1> </StackItem>
                                  <StackItem> <Body1> <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" /> </Body1> </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          }
                        </>
                      </StackItem>
                      <StackItem>
                        <>
                          {
                            (selectedOption === 'weekly') &&
                            <Stack tokens={{ childrenGap: 20 }}>
                              <StackItem>
                                <Stack>
                                  <StackItem><Text></Text></StackItem>
                                  <StackItem>
                                    <Stack horizontal tokens={{ childrenGap: 20 }}>
                                      {daysOfWeek.map((day) => (
                                        <StackItem key={day}>
                                          <Button shape="circular" size="medium" appearance={clickedDays[`isWeeklyButton${day}Clicked`] ? 'primary' : 'outline'} onClick={() => handleWeeklyButtonClick(day)}>
                                            {day.substring(0, 3)}
                                          </Button>
                                        </StackItem>
                                      ))}
                                    </Stack>
                                  </StackItem>
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack horizontal>
                                  <StackItem><Text></Text></StackItem>
                                  <StackItem>
                                    <Stack tokens={{ childrenGap: 10 }}>
                                      <Text> At what time should scheduler execute? <Image src="/Dashboard/image/required.svg" /></Text>
                                      <StackItem>
                                        <Stack tokens={{ childrenGap: 20 }} horizontal>
                                          <StackItem>
                                            {configFormData.executionTime[0]?.time?.length > 0 ? <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} defaultValue={new Date(`November 25, 2023 ${configFormData.executionTime[0]?.time}:00`)} /> : <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} />}
                                          </StackItem>
                                            <StackItem>
                                              <Stack tokens={{ childrenGap: 5 }}>
                                                <StackItem><Text></Text></StackItem>
                                                <StackItem> <AddSquare20Filled {...primaryIcon} onClick={handleWeeklyAddClone} /> </StackItem>
                                              </Stack>
                                            </StackItem>
                                        </Stack>
                                      </StackItem>
                                    </Stack>
                                  </StackItem>
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack horizontal>
                                  <StackItem><Text></Text></StackItem>
                                  <StackItem>
                                    {cloneWeeklyForms.map((formWeekly) => (
                                      <Stack key={formWeekly.id}>
                                        <Stack horizontal tokens={{ childrenGap: 480 }}>
                                          <StackItem>
                                            {(selectedOption === 'weekly') &&
                                              <Stack horizontal tokens={{ childrenGap: 20 }}>
                                                <Stack tokens={{ childrenGap: 20 }} horizontal>
                                                  <StackItem> <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, formWeekly.id) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, formWeekly.id) }} /> </StackItem>
                                                  <StackItem>
                                                    <Stack tokens={{ childrenGap: 5 }}>
                                                      <StackItem><Text></Text></StackItem>
                                                      <StackItem> <Delete20Regular {...deleteIcon} onClick={() => handleRemoveWeeklyClone(formWeekly.id)} />  </StackItem>
                                                    </Stack>
                                                  </StackItem>
                                                </Stack>
                                              </Stack>
                                            }
                                          </StackItem>
                                        </Stack>
                                        <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                      </Stack>
                                    ))}
                                  </StackItem>
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack>
                                  <StackItem> <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1> </StackItem>
                                  <StackItem> <Body1> <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" /> </Body1> </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          }
                        </>
                      </StackItem>
                      <StackItem>
                        <>
                          {
                            (selectedOption == 'monthly') &&
                            <Stack tokens={{ childrenGap: 10 }}>
                              <StackItem>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                  {months.slice(0, 6).map((month) => (
                                    <StackItem key={month}>
                                      <Button shape="circular" size="medium" appearance={clickedMonths[`isMonthButton${month}Clicked`] ? 'primary' : 'outline'} onClick={() => handleMonthButtonClick(month)} >
                                        {month}
                                      </Button>
                                    </StackItem>
                                  ))}
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                  {months.slice(6).map((month) => (
                                    <StackItem key={month}>
                                      <Button shape="circular" size="medium" appearance={clickedMonths[`isMonthButton${month}Clicked`] ? 'primary' : 'outline'} onClick={() => handleMonthButtonClick(month)} >
                                        {month}
                                      </Button>
                                    </StackItem>
                                  ))}
                                </Stack>
                              </StackItem>
                              <StackItem>
                                <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                <Stack>
                                  <StackItem>
                                    <Body1> On which date should the scheduler execute? </Body1>
                                    <StackItem grow>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                          {/* <DatePicker onSelectDate={(e: any) => {handleDatepicker(e,0)}} placeholder="Enter Date Here"/>  */}

                                          <Dropdown value={configFormData?.date ? configFormData?.date[0]?.date : ''} placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium">
                                            {dates.map((val) =>
                                              <Option key={`op_${val}`} text={val} value={val} onClick={() => { handleDatepicker(parseInt(val), 0) }}>
                                                {val}
                                              </Option>
                                            )}
                                          </Dropdown>
                                        </StackItem>
                                        <Stack tokens={{ childrenGap: 307 }} horizontal>
                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }}>
                                              <StackItem><Text></Text></StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 15 }} horizontal>
                                                  <StackItem><Text></Text></StackItem>
                                                  <StackItem> <AddSquare20Regular {...primaryIcon} onClick={handleMonthlyAddCloneDate} /> </StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                        </Stack>
                                      </Stack>
                                    </StackItem>
                                  </StackItem>
                                </Stack>
                                {/* WRITE MONTHLY CLONE DATE STARTS HERE */}
                                <StackItem>
                                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                                    <StackItem>
                                      <Text>&nbsp;</Text>
                                    </StackItem>
                                  </Stack>
                                  {cloneMonthlyFormsDate.map((formMonthlyDate: any, i: any) => (
                                    <Stack key={formMonthlyDate.id}>
                                      <Stack horizontal tokens={{ childrenGap: 480 }}>
                                        <StackItem grow>
                                          {(selectedOption === 'monthly') &&
                                            <Stack horizontal tokens={{ childrenGap: 20 }}>
                                              <Stack tokens={{ childrenGap: 20 }} horizontal>
                                                <StackItem>
                                                  {/* <DatePicker onSelectDate={(e: any) => {handleDatepicker(e,formMonthlyDate.id)}} onKeyUp={(e: any) => {handleDatepicker(e,formMonthlyDate.id)}} placeholder = "Enter Date Here......................." />  */}

                                                  <Dropdown value={configFormData?.date ? configFormData?.date[i + 1]?.date : ''} placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium">
                                                    {dates.map((val) =>
                                                      <Option key={`op_${val}`} text={val} value={val} onClick={() => { handleDatepicker(parseInt(val), formMonthlyDate.id) }}>
                                                        {val}
                                                      </Option>
                                                    )}
                                                  </Dropdown>
                                                </StackItem>
                                                <StackItem>
                                                  <Stack tokens={{ childrenGap: 5 }}>
                                                    <StackItem><Text></Text></StackItem>
                                                    <StackItem> <Delete20Regular {...deleteIcon} onClick={() => handleRemoveMonthlyCloneDate(formMonthlyDate.id)} /> </StackItem>
                                                  </Stack>
                                                </StackItem>
                                              </Stack>
                                            </Stack>
                                          }
                                        </StackItem>
                                      </Stack>
                                      <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                    </Stack>
                                  ))}
                                </StackItem>
                                {/* WRITE MONTHLY CLONE DATE ENDS HERE */}
                                <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                <Stack>
                                  <StackItem>
                                    <Body1> At what time should the scheduler execute?? <Image src="/Dashboard/image/required.svg" /></Body1>
                                    <StackItem grow>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem grow>
                                          {configFormData.executionTime[0]?.time?.length > 0 ? <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} defaultValue={new Date(`November 25, 2023 ${configFormData.executionTime[0]?.time}:00`)} /> : <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, 0) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, 0) }} />}
                                        </StackItem>
                                        <Stack tokens={{ childrenGap: 307 }} horizontal>
                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }}>
                                              <StackItem><Text></Text></StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 15 }} horizontal>
                                                  <StackItem><Text></Text></StackItem>
                                                  <StackItem> <AddSquare20Filled {...primaryIcon} onClick={handleMonthlyAddClone}/> </StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </StackItem>
                                          <StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem>
                                        </Stack>
                                      </Stack>
                                    </StackItem>
                                  </StackItem>
                                </Stack>
                              </StackItem>
                              {/* WRITE MONTHLY CLONE TIME STARTS HERE */}
                              <StackItem>
                                {cloneMonthlyFormsTime.map((formMonthlyTime) => (
                                  <Stack key={formMonthlyTime.id}>
                                    <Stack horizontal tokens={{ childrenGap: 480 }}>
                                      <StackItem>
                                        {(selectedOption === 'monthly') &&
                                          <Stack horizontal tokens={{ childrenGap: 20 }}>
                                            <Stack tokens={{ childrenGap: 20 }} horizontal>
                                              <StackItem>
                                                <TimePicker placeholder="Enter Time Here" onChange={(e: any) => { handleTimepicker(e.target.innerText, formMonthlyTime.id) }} onKeyUp={(e: any) => { handleTimepicker(e.target.value, formMonthlyTime.id) }} />
                                              </StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 5 }}>
                                                  <StackItem><Text></Text></StackItem>
                                                  <StackItem> <Delete20Regular {...deleteIcon} onClick={() => handleRemoveMonthlyCloneTime(formMonthlyTime.id)} /> </StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </Stack>
                                        }
                                      </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                  </Stack>
                                ))}
                              </StackItem>
                              {/* WRITE MONTHLY CLONE TIME ENDS HERE */}
                              <StackItem>
                                <Stack>
                                  <StackItem> <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1> </StackItem>
                                  <StackItem> <Body1> <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" /> </Body1> </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          }
                        </>
                      </StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </>
              <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
            </form>,

          "Review Data":
            <>
              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong> Name of the automation schedule </Body1Strong> </StackItem>
                    <StackItem> <Inputs inputChange={setFormData} inputVal={formData} disabled={true} /> </StackItem>
                  </Stack>
                </StackItem>

                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong> Description </Body1Strong> </StackItem>
                    <StackItem> <Resize inputChange={setFormData} inputValue={formData} disabled={true} /> </StackItem>
                  </Stack>
                </StackItem>

                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong>Automation that you Scheduled Selfhelp</Body1Strong> </StackItem>
                    <StackItem>
                      {selectedOptions?.length > 0 && <Badge color="informative">{selectedOptions[0]}</Badge>}
                    </StackItem>
                  </Stack>
                </StackItem>

                <StackItem>
                  <Stack tokens={{ padding: 10 }}>
                    <StackItem>
                      <>
                        {
                          (selectedOption == 'daily') &&
                          <Stack tokens={{ childrenGap: 20 }}>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 3 }}>
                                <StackItem>
                                  <Body1Strong>
                                    At what time should the scheduler execute?
                                  </Body1Strong>
                                </StackItem>
                                <StackItem>
                                  * This Schedule to be exuted at {configFormData?.executionTime[0]?.time} {configFormData.weekend == true && "on weekends"}
                                </StackItem>
                                <StackItem>
                                  {/* <Checkbox checked={configFormData.weekend} onChange={handleWeekendCheckbox} label="Include Weekends" disabled={true} />  */}
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              {/* {cloneDailyForms.map((formDaily: any, i: any) => (
                              <Stack key={formDaily.id}>
                                <Stack horizontal tokens={{childrenGap:480}}>
                                  <StackItem>
                                    {(selectedOption ==='daily') && 
                                    <Stack horizontal tokens={{childrenGap:20}}>
                                      <Stack tokens={{childrenGap:25}} horizontal>
                                        <StackItem> 
                                          <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[i+1]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                          </Dropdown>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                    }
                                  </StackItem>
                                </Stack>
                                <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                              </Stack>
                            ))} */}
                            </StackItem>
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Body1Strong>
                                    In the case of a missed schedule, what is the the recommended course of action?
                                  </Body1Strong>
                                </StackItem>
                                <StackItem>
                                  * {configFormData.recommendedAction == 1 ? "Execute earliest available opportunity" : "Execute next available schedule "}
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        }
                        {/* {  
                        (selectedOption == 'daily') &&
                        <Stack tokens={{childrenGap:20}}>
                          <StackItem>
                            <Stack tokens={{childrenGap:20}} horizontal>
                              <StackItem> 
                                <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                  </Dropdown>
                              </StackItem>
                              <StackItem> 
                                <Checkbox checked={configFormData.weekend} onChange={handleWeekendCheckbox} label="Include Weekends" disabled={true} /> 
                              </StackItem>
                            </Stack>
                          </StackItem>
                          <StackItem>
                            {cloneDailyForms.map((formDaily: any, i: any) => (
                              <Stack key={formDaily.id}>
                                <Stack horizontal tokens={{childrenGap:480}}>
                                  <StackItem>
                                    {(selectedOption ==='daily') && 
                                    <Stack horizontal tokens={{childrenGap:20}}>
                                      <Stack tokens={{childrenGap:25}} horizontal>
                                        <StackItem> 
                                          <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[i+1]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                          </Dropdown>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                    }
                                  </StackItem>
                                </Stack>
                                <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                              </Stack>
                            ))}
                          </StackItem>
                          <StackItem>
                            <Stack>
                              <StackItem> 
                                <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1> 
                              </StackItem>
                              <StackItem> 
                                <Body1> 
                                  <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" disabled={true} /> 
                                </Body1>
                              </StackItem>
                            </Stack>
                          </StackItem>
                        </Stack>
                      } */}
                      </>
                    </StackItem>
                    <StackItem>
                      <>
                        {
                          (selectedOption == 'weekly') &&
                          <Stack tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <Stack>
                                <StackItem><Text></Text></StackItem>
                                {/* <StackItem> 
                                <Stack horizontal tokens={{childrenGap:20}}>
                                  {daysOfWeek.map((day) => (
                                    <StackItem key={day}>
                                      <Button shape="circular" disabled={true} size="medium" appearance={clickedDays[`isWeeklyButton${day}Clicked`] ? 'primary' : 'outline'} onClick={() => handleWeeklyButtonClick(day)}>
                                        {day.substring(0, 3)}
                                      </Button>
                                    </StackItem>
                                  ))}
                                </Stack>
                              </StackItem> */}
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack horizontal>
                                <StackItem><Text></Text></StackItem>
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 5 }}>
                                    <Body1Strong> At what time should scheduler execute?</Body1Strong>
                                    <StackItem>
                                      <StackItem>
                                        <StackItem>
                                          * This Schedule to be exuted at {configFormData?.executionTime[0]?.time} {configFormData.weekend == true && "on weekends"} on {configFormData?.days?.map((i: any) => i).join(",")}
                                        </StackItem>
                                      </StackItem>
                                    </StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 5 }} horizontal>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Body1Strong> In the case of a missed schedule, what is the the recommended course of action? </Body1Strong>
                                </StackItem>
                                <StackItem>
                                  <Body1>
                                    * {configFormData.recommendedAction == 1 ? "Execute earliest available opportunity" : "Execute next available schedule "}
                                  </Body1>
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        }
                        {/* {
                        (selectedOption == 'weekly') &&
                        <Stack tokens={{childrenGap:20}}>
                          <StackItem>
                            <Stack>
                              <StackItem><Text></Text></StackItem>
                              <StackItem> 
                                <Stack horizontal tokens={{childrenGap:20}}>
                                  {daysOfWeek.map((day) => (
                                    <StackItem key={day}>
                                      <Button shape="circular" disabled={true} size="medium" appearance={clickedDays[`isWeeklyButton${day}Clicked`] ? 'primary' : 'outline'} onClick={() => handleWeeklyButtonClick(day)}>
                                        {day.substring(0, 3)}
                                      </Button>
                                    </StackItem>
                                  ))}
                                </Stack>
                              </StackItem>
                            </Stack>
                          </StackItem>
                          <StackItem>
                            <Stack horizontal>
                              <StackItem><Text></Text></StackItem>
                              <StackItem>
                                <Stack tokens={{childrenGap:10}}>
                                  <Text> At what time should scheduler execute?<Image src="/Dashboard/image/required.svg" /> </Text>
                                  <StackItem>
                                    <Stack tokens={{childrenGap:20}} horizontal>
                                      <StackItem>
                                        <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                        </Dropdown>
                                      </StackItem>
                                    </Stack>
                                  </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          </StackItem>
                          <StackItem>
                            <Stack tokens={{childrenGap:10}} horizontal>
                              <StackItem><Text></Text></StackItem>
                              <StackItem>
                                {cloneWeeklyForms.map((formWeekly: any, i: any) => (
                                  <Stack key={formWeekly.id}>
                                    <Stack horizontal tokens={{childrenGap:480}}>
                                      <StackItem>
                                        {(selectedOption ==='weekly') && 
                                        <Stack horizontal tokens={{childrenGap:20}}>
                                          <Stack tokens={{childrenGap:20}} horizontal>
                                            <StackItem>
                                              <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[i+1]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                              </Dropdown>
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                        }
                                      </StackItem>
                                    </Stack>
                                    <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                  </Stack>
                                ))}
                              </StackItem>
                            </Stack>
                          </StackItem>
                            <StackItem>
                            <Stack>
                              <StackItem> 
                                <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1> 
                              </StackItem>
                              <StackItem>
                                <Body1> 
                                  <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" disabled={true} /> 
                                </Body1> 
                              </StackItem>
                            </Stack>
                          </StackItem>
                        </Stack>
                      } */}
                      </>
                    </StackItem>
                    <StackItem>
                      <>
                        {
                          (selectedOption == 'monthly') &&
                          <Stack tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              {/* <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack> */}
                              <Stack>
                                <StackItem>
                                  <Body1Strong> On which date should the scheduler execute? </Body1Strong>
                                  <StackItem grow>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem grow>
                                        {/* <Dropdown value={configFormData?.date ? configFormData?.date[0]?.date : ''}placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                                      </Dropdown> */}
                                        <StackItem>
                                          * This Schedule to be exuted at {configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} on {configFormData?.date ? configFormData?.date[0]?.date : ''}th of {configFormData?.months?.map((i: any) => i).join(",")} {/* on {configFormData.weekend == true && "on weekends"}*/}
                                        </StackItem>
                                      </StackItem>
                                    </Stack>
                                  </StackItem>
                                </StackItem>
                              </Stack>
                              {/* WRITE MONTHLY CLONE DATE STARTS HERE */}
                              <StackItem>
                                <Stack horizontal tokens={{ childrenGap: 20 }}>
                                  <StackItem>
                                    {/* <Text>&nbsp;</Text> */}
                                  </StackItem>
                                </Stack>
                                {cloneMonthlyFormsDate.map((formMonthlyDate: any, i: any) => (
                                  <Stack key={formMonthlyDate.id}>
                                    <Stack horizontal tokens={{ childrenGap: 480 }}>
                                      <StackItem grow>
                                        {(selectedOption === 'monthly') &&
                                          <Stack horizontal tokens={{ childrenGap: 20 }}>
                                            <Stack tokens={{ childrenGap: 20 }} horizontal>
                                              <StackItem grow>
                                                * This Schedule to be exuted at {configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} on {configFormData?.date ? configFormData?.date[i + 1]?.date : ''}th of {configFormData?.months?.map((i: any) => i).join(",")} {/* on {configFormData.weekend == true && "on weekends"}*/}
                                              </StackItem>
                                            </Stack>
                                          </Stack>
                                        }
                                      </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                  </Stack>
                                ))}
                              </StackItem>
                              {/* WRITE MONTHLY CLONE DATE ENDS HERE */}
                              {/* <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack> */}
                              <Stack>
                                {/* <StackItem> 
                                <Body1Strong> At what time should the scheduler execute? </Body1Strong>
                                <StackItem grow>  
                                  <Stack tokens={{childrenGap:5}} horizontal>
                                    <StackItem grow> 
                                      <StackItem>
                                      * This Schedule to be exuted at {configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''}
                                      </StackItem>
                                    </StackItem>
                                  </Stack>
                                </StackItem>
                              </StackItem> */}
                              </Stack>
                            </StackItem>
                            {/* WRITE MONTHLY CLONE TIME STARTS HERE */}
                            <StackItem>
                              {cloneMonthlyFormsTime.map((formMonthlyTime) => (
                                <Stack key={formMonthlyTime.id}>
                                  <Stack horizontal tokens={{ childrenGap: 480 }}>
                                    <StackItem>
                                      {(selectedOption === 'monthly') &&
                                        <Stack horizontal tokens={{ childrenGap: 20 }}>
                                          <Stack tokens={{ childrenGap: 20 }} horizontal>
                                            <StackItem>
                                              *3{configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} on {configFormData?.months} on {configFormData.weekend == true && "on weekends"}
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                      }
                                    </StackItem>
                                  </Stack>
                                  <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                </Stack>
                              ))}
                            </StackItem>
                            {/* WRITE MONTHLY CLONE TIME ENDS HERE */}
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Body1Strong> In the case of a missed schedule, what is the the recommended course of action? </Body1Strong>
                                </StackItem>
                                <StackItem>
                                  * {configFormData.recommendedAction == 1 ? "Execute earliest available opportunity" : "Execute next available schedule "}
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        }

                        {
                          // (selectedOption == 'monthly') &&
                          // <Stack tokens={{childrenGap:10}}>
                          //   <StackItem>
                          //     <Stack horizontal tokens={{childrenGap:10}}>
                          //       {months.slice(0, 6).map((month) => (
                          //         <StackItem key={month}>
                          //             <Button shape="circular" size="medium" appearance={clickedMonths[`isMonthButton${month}Clicked`] ? 'primary' : 'outline'} onClick={() => handleMonthButtonClick(month)} disabled={true} >
                          //               {month}
                          //             </Button>
                          //           </StackItem>
                          //         ))}
                          //       </Stack>
                          //   </StackItem>
                          //   <StackItem>
                          //     <Stack horizontal tokens={{childrenGap:10}}>
                          //       {months.slice(6).map((month) => (
                          //         <StackItem key={month}>
                          //           <Button shape="circular" size="medium" appearance={clickedMonths[`isMonthButton${month}Clicked`] ? 'primary' : 'outline'} onClick={() => handleMonthButtonClick(month)} disabled={true} >
                          //             {month}
                          //           </Button>
                          //         </StackItem>
                          //       ))}
                          //     </Stack>
                          //   </StackItem>
                          //   <StackItem>
                          //     <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                          //     <Stack>
                          //       <StackItem> 
                          //         <Body1> On which date should the scheduler execute? <Image src="/Dashboard/image/required.svg" /></Body1>
                          //         <StackItem grow>  
                          //           <Stack tokens={{childrenGap:5}} horizontal>
                          //             <StackItem grow> 
                          //               <Dropdown value={configFormData?.date ? configFormData?.date[0]?.date : ''}placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                          //               </Dropdown>
                          //             </StackItem>
                          //           </Stack>
                          //         </StackItem>
                          //       </StackItem>
                          //     </Stack>
                          //     {/* WRITE MONTHLY CLONE DATE STARTS HERE */}
                          //     <StackItem>
                          //       <Stack horizontal tokens={{childrenGap:20}}>
                          //         <StackItem>
                          //           <Text>&nbsp;</Text>
                          //         </StackItem>
                          //       </Stack> 
                          //       {cloneMonthlyFormsDate.map((formMonthlyDate: any, i: any) => (
                          //         <Stack key={formMonthlyDate.id}>
                          //           <Stack horizontal tokens={{childrenGap:480}}>
                          //             <StackItem grow>
                          //               {(selectedOption ==='monthly') && 
                          //               <Stack horizontal tokens={{childrenGap:20}}>
                          //                 <Stack tokens={{childrenGap:20}} horizontal>
                          //                   <StackItem grow> 
                          //                     <Dropdown value={configFormData?.date ? configFormData?.date[i+1]?.date : ''}placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                          //                     </Dropdown>
                          //                   </StackItem>
                          //                 </Stack>
                          //               </Stack>
                          //               }
                          //             </StackItem>
                          //           </Stack>
                          //           <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                          //         </Stack>
                          //       ))}
                          //     </StackItem>
                          //     {/* WRITE MONTHLY CLONE DATE ENDS HERE */}
                          //     <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                          //     <Stack>
                          //       <StackItem> 
                          //         <Body1> At what time should the scheduler execute? <Image src="/Dashboard/image/required.svg" /></Body1>
                          //         <StackItem grow>  
                          //           <Stack tokens={{childrenGap:5}} horizontal>
                          //             <StackItem grow> 
                          //               <Dropdown value={configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''}placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                          //               </Dropdown>
                          //             </StackItem>
                          //           </Stack>
                          //         </StackItem>
                          //       </StackItem>
                          //     </Stack>
                          //   </StackItem>
                          //   {/* WRITE MONTHLY CLONE TIME STARTS HERE */}
                          //   <StackItem>
                          //     {cloneMonthlyFormsTime.map((formMonthlyTime) => (
                          //       <Stack key={formMonthlyTime.id}>
                          //         <Stack horizontal tokens={{childrenGap:480}}>
                          //           <StackItem>
                          //             {(selectedOption ==='monthly') && 
                          //             <Stack horizontal tokens={{childrenGap:20}}>
                          //               <Stack tokens={{childrenGap:20}} horizontal>
                          //                 <StackItem> 
                          //                   <Dropdown value={configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''}placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                          //                   </Dropdown> 
                          //                 </StackItem>
                          //               </Stack>
                          //             </Stack>
                          //             }
                          //           </StackItem>
                          //         </Stack>
                          //         <Stack tokens={{childrenGap:20}}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                          //       </Stack>
                          //     ))}
                          //   </StackItem>
                          //   {/* WRITE MONTHLY CLONE TIME ENDS HERE */}
                          //   <StackItem>
                          //     <Stack>
                          //       <StackItem> 
                          //         <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1> 
                          //       </StackItem>
                          //       <StackItem> 
                          //         <Body1> 
                          //           <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" disabled={true} /> 
                          //         </Body1> 
                          //       </StackItem>
                          //     </Stack>
                          //   </StackItem>
                          // </Stack>
                        }
                      </>
                    </StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </>,
        },
      });

      overlayName === 'editAutomation' && automationStatus !== 'not attached' && setAutomationOverLayData({
        headerTitle: `${selectedAutomation} automation`,
        size: "large",
        isTabs: true,
        tabItems:
        {
          Configuration:spinnerLoad?
          <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner/>
          </Stack>:
            <>
              <Stack tokens={{ childrenGap: "10px 0px" }}>
                <InfoBar showSpaces={false} title={"Editing is disabled for this automation as it is associated with a Tenant or Device Classification. To make changes, please detach it first."} />
                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong> Name of the automation schedule </Body1Strong> </StackItem>
                    <StackItem> <Inputs inputChange={setFormData} inputVal={formData} disabled={true} /> </StackItem>
                  </Stack>
                </StackItem>

                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong> Description </Body1Strong> </StackItem>
                    <StackItem> <Resize inputChange={setFormData} inputValue={formData} disabled={true} /> </StackItem>
                  </Stack>
                </StackItem>

                <StackItem>
                  <Stack>
                    <StackItem> <Body1Strong>Scheduled selfhelp</Body1Strong> </StackItem>
                    <StackItem>
                      {selectedOptions?.length > 0 && <Badge color="informative">{selectedOptions[0]}</Badge>}
                    </StackItem>
                  </Stack>
                </StackItem>

                <StackItem>
                  <Stack tokens={{ padding: "10px 0px" }}>
                    <StackItem>
                      <>
                        {
                          (selectedOption == 'daily') &&
                          <Stack tokens={{ childrenGap: 20 }}>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 20 }} horizontal>
                                <StackItem>
                                  <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                  </Dropdown>
                                </StackItem>
                                <StackItem>
                                  <Checkbox checked={configFormData.weekend} onChange={handleWeekendCheckbox} label="Include Weekends" disabled={true} />
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              {cloneDailyForms.map((formDaily: any, i: any) => (
                                <Stack key={formDaily.id}>
                                  <Stack horizontal tokens={{ childrenGap: 480 }}>
                                    <StackItem>
                                      {(selectedOption === 'daily') &&
                                        <Stack horizontal tokens={{ childrenGap: 20 }}>
                                          <Stack tokens={{ childrenGap: 25 }} horizontal>
                                            <StackItem>
                                              <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[i + 1]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                              </Dropdown>
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                      }
                                    </StackItem>
                                  </Stack>
                                  <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                </Stack>
                              ))}
                            </StackItem>
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1>
                                </StackItem>
                                <StackItem>
                                  <Body1>
                                    <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" disabled={true} />
                                  </Body1>
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        }
                      </>
                    </StackItem>
                    <StackItem>
                      <>
                        {
                          (selectedOption == 'weekly') &&
                          <Stack tokens={{ childrenGap: 20 }}>
                            <StackItem>
                              <Stack>
                                <StackItem><Text></Text></StackItem>
                                <StackItem>
                                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                                    {daysOfWeek.map((day) => (
                                      <StackItem key={day}>
                                        <Button shape="circular" disabled={true} size="medium" appearance={clickedDays[`isWeeklyButton${day}Clicked`] ? 'primary' : 'outline'} onClick={() => handleWeeklyButtonClick(day)}>
                                          {day.substring(0, 3)}
                                        </Button>
                                      </StackItem>
                                    ))}
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack horizontal>
                                <StackItem><Text></Text></StackItem>
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 10 }}>
                                    <Text> At what time should scheduler execute?<Image src="/Dashboard/image/required.svg" /> </Text>
                                    <StackItem>
                                      <Stack tokens={{ childrenGap: 20 }} horizontal>
                                        <StackItem>
                                          <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                          </Dropdown>
                                        </StackItem>
                                      </Stack>
                                    </StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 10 }} horizontal>
                                <StackItem><Text></Text></StackItem>
                                <StackItem>
                                  {cloneWeeklyForms.map((formWeekly: any, i: any) => (
                                    <Stack key={formWeekly.id}>
                                      <Stack horizontal tokens={{ childrenGap: 480 }}>
                                        <StackItem>
                                          {(selectedOption === 'weekly') &&
                                            <Stack horizontal tokens={{ childrenGap: 20 }}>
                                              <Stack tokens={{ childrenGap: 20 }} horizontal>
                                                <StackItem>
                                                  <Dropdown disabled={true} value={configFormData?.executionTime ? configFormData?.executionTime[i + 1]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium">
                                                  </Dropdown>
                                                </StackItem>
                                              </Stack>
                                            </Stack>
                                          }
                                        </StackItem>
                                      </Stack>
                                      <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                    </Stack>
                                  ))}
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1>
                                </StackItem>
                                <StackItem>
                                  <Body1>
                                    <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" disabled={true} />
                                  </Body1>
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        }
                      </>
                    </StackItem>
                    <StackItem>
                      <>
                        {
                          (selectedOption == 'monthly') &&
                          <Stack tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <Stack horizontal tokens={{ childrenGap: 10 }}>
                                {months.slice(0, 6).map((month) => (
                                  <StackItem key={month}>
                                    <Button shape="circular" size="medium" appearance={clickedMonths[`isMonthButton${month}Clicked`] ? 'primary' : 'outline'} onClick={() => handleMonthButtonClick(month)} disabled={true} >
                                      {month}
                                    </Button>
                                  </StackItem>
                                ))}
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack horizontal tokens={{ childrenGap: 10 }}>
                                {months.slice(6).map((month) => (
                                  <StackItem key={month}>
                                    <Button shape="circular" size="medium" appearance={clickedMonths[`isMonthButton${month}Clicked`] ? 'primary' : 'outline'} onClick={() => handleMonthButtonClick(month)} disabled={true} >
                                      {month}
                                    </Button>
                                  </StackItem>
                                ))}
                              </Stack>
                            </StackItem>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                              <Stack>
                                <StackItem>
                                  <Body1> On which date should the scheduler execute? <Image src="/Dashboard/image/required.svg" /></Body1>
                                  <StackItem grow>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem grow>
                                        <Dropdown value={configFormData?.date ? configFormData?.date[0]?.date : ''} placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                                        </Dropdown>
                                      </StackItem>
                                    </Stack>
                                  </StackItem>
                                </StackItem>
                              </Stack>
                              {/* WRITE MONTHLY CLONE DATE STARTS HERE */}
                              <StackItem>
                                <Stack horizontal tokens={{ childrenGap: 20 }}>
                                  <StackItem>
                                    <Text>&nbsp;</Text>
                                  </StackItem>
                                </Stack>
                                {cloneMonthlyFormsDate.map((formMonthlyDate: any, i: any) => (
                                  <Stack key={formMonthlyDate.id}>
                                    <Stack horizontal tokens={{ childrenGap: 480 }}>
                                      <StackItem grow>
                                        {(selectedOption === 'monthly') &&
                                          <Stack horizontal tokens={{ childrenGap: 20 }}>
                                            <Stack tokens={{ childrenGap: 20 }} horizontal>
                                              <StackItem grow>
                                                <Dropdown value={configFormData?.date ? configFormData?.date[i + 1]?.date : ''} placeholder="Enter Date Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                                                </Dropdown>
                                              </StackItem>
                                            </Stack>
                                          </Stack>
                                        }
                                      </StackItem>
                                    </Stack>
                                    <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                  </Stack>
                                ))}
                              </StackItem>
                              {/* WRITE MONTHLY CLONE DATE ENDS HERE */}
                              <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                              <Stack>
                                <StackItem>
                                  <Body1> At what time should the scheduler execute? <Image src="/Dashboard/image/required.svg" /></Body1>
                                  <StackItem grow>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem grow>
                                        <Dropdown value={configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                                        </Dropdown>
                                      </StackItem>
                                    </Stack>
                                  </StackItem>
                                </StackItem>
                              </Stack>
                            </StackItem>
                            {/* WRITE MONTHLY CLONE TIME STARTS HERE */}
                            <StackItem>
                              {cloneMonthlyFormsTime.map((formMonthlyTime) => (
                                <Stack key={formMonthlyTime.id}>
                                  <Stack horizontal tokens={{ childrenGap: 480 }}>
                                    <StackItem>
                                      {(selectedOption === 'monthly') &&
                                        <Stack horizontal tokens={{ childrenGap: 20 }}>
                                          <Stack tokens={{ childrenGap: 20 }} horizontal>
                                            <StackItem>
                                              <Dropdown value={configFormData?.executionTime ? configFormData?.executionTime[0]?.time : ''} placeholder="Enter Time Here" aria-labelledby={dropdownId} size="medium" disabled={true}>
                                              </Dropdown>
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                      }
                                    </StackItem>
                                  </Stack>
                                  <Stack tokens={{ childrenGap: 20 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                                </Stack>
                              ))}
                            </StackItem>
                            {/* WRITE MONTHLY CLONE TIME ENDS HERE */}
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Body1> In the case of a missed schedule, what is the the recommended course of action? </Body1>
                                </StackItem>
                                <StackItem>
                                  <Body1>
                                    <RadioGroups defaultValue={configFormData.recommendedAction} onChange={handleRadioGrps} data={radioData1} layout="horizontal" disabled={true} />
                                  </Body1>
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        }
                      </>
                    </StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </>,
        },
      });
    }
    console.log("selected options slength", selectedOptions);
  }, [dartSpecs, overlayName, formData, selectedOption, showAdditionalContent, cloneWeeklyForms, clickedDays, cloneDailyForms, automationSearchData, configFormData, cloneMonthlyFormsDate, cloneMonthlyFormsTime, selectedOptions, classificationNameValidation]);
  // overflow set contents code ends here

  useEffect(() => {
    console.log("rowID=", rowID);

  }, [rowID]);

  var tempTableData: any = [];
  var menuLists: any = [];

  useEffect(() => {
    var tempExportData: any = [];
    var status = '';

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      if (val.status == 'not attached') {
        status = 'Not attached';
      } else {
        var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

        if (curStatus.length === 0) {
          status = 'Enabled for other tenant';
        } else {
          curStatus = curStatus[0]?.split(":")[1];

          if (curStatus == 'all') {
            status = 'Enabled for All Devices';
          } else {
            status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
          }
        }
      }

      tempExportData.push({
        'Name': val.automationName,
        'Description': val.description,
        'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
        'Created On': convertToExcelFormat(val.createdOn),
        'Last Modified': val.lastModified ? convertToExcelFormat(val.lastModified) : "-",
        'Status': status,
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);
  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueCreatedBy: string[] = [];

      final_data?.forEach((val: any) => {
        if (val.createdBy && val.createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.createdBy)) {
          newUniqueCreatedBy.push(val.createdBy);
        }
      });

      setUniqueCreatedBy(newUniqueCreatedBy);
      console.log("Unique Created By:", newUniqueCreatedBy);
    } else {
      setUniqueCreatedBy([]);
    }
  }, [final_data]);

  useEffect(() => {
    // data table values append code starts here
    console.log("final_data=", final_data);

    var status = '';
    final_data !== undefined && final_data !== null ?
      final_data.map((val: any, i: any) => {
        if (val.status == 'not attached') {
          status = 'Not attached';
        } else {
          var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

          if (curStatus.length === 0) {
            status = 'Enabled for other tenant';
          } else {
            curStatus = curStatus[0]?.split(":")[1];

            if (curStatus == 'all') {
              status = 'Enabled for All Devices';
            } else {
              status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
            }
          }
        }

        {
          permissions.includes("all") || permissions.includes("automationSchedule_Fullaccess") ?
            tempTableData.push({
              id: val.id,
              checkbox: "show",
              name: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={(e: any) => {setSpinnerLoad(true); setOverlayOpen(true); setOverlayName('editAutomation'); setRowID(val.id); val.status.includes(`${contextValue.tenantName}:`) ? setAutomationStatus('attached') : setAutomationStatus('not attached'); setFormData({ ...formData, name: '', description: '', jsonData: {} }); setAutomationSearchVal(""); setSelectedAutomation(val.automationName); }}> {val.automationName} </Button> },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            })
            :
            tempTableData.push({
              id: val.id,
              checkbox: "hide",
              name: {
                label: <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                  <Button  id="ButtonHover" style={buttonContent} appearance="transparent" size="small"> {val.automationName} </Button>
                </Tooltip>
              },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            })
        }
      }) : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
      if (isRefresh) {
        console.log("FIRST CALL");
        setRefresh(false);
        setRefreshToast(true);
        setTimeout(() => {
        setRefreshToast(false);
        }, 3000);
    }
    }, 500);
  }, [final_data, permissions]);
  // data table values append code ends here

  useEffect(() => {
    !overlayOpen && setOverlayName('');
    setFormData({ name: '', description: '', jsonData: { type: '' } });
  }, [overlayOpen]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
  }, [contextValue.selectedRowIdInTable]);

  useEffect(() => {
    const pageNo = (currentPageNo - 1) * 50;

    const props: any = {
      automationSearchVal: automationSearchVal,
      rowID: rowID,
      tenant: tenantName,
      newData: formData,
      saveBtnClicked: saveBtnClicked,
      dartNo: dartNo,
      setAutomationSearchData: setAutomationSearchData,
      setOverlayName: setOverlayName,
      setSaveBtnClicked: setSaveBtnClicked,
      setSaveTriggered: setSaveTriggered,
      setOverlayOpen: setOverlayOpen,
      setErrorToast: setErrorToast,
      setToastMessage: setToastMessage,
      setIsToast: setIsToast,
      data: final_data,
      func: set_final_data,
      searchVal: searchVal,
      pageNo: pageNo,
      setTotalPages: setTotalPages,
      setTotalRecords: setTotalRecords,
      setDartSpecs: setDartSpecs,
      dartSpecs: dartSpecs,
      deleteAutomation: deleteAutomation,
      setDeleteAutomation: setDeleteAutomation,
      setDeleteDisabled: setDeleteDisabled,
      isRefresh: isRefresh,
      setRefresh: setRefresh,
      setIsRefresh: setRefresh,
      setRefreshToast: setRefreshToast,
      isFilter: isFilter,
      dropDownValue1: dropDownValue1,
      setIsFilter: setIsFilter,
      dropdownValue2: dropDownValue2,
      filterArray: filterArray,
      overlayName: overlayName,
      formData: formData,
      setFormData: setFormData,
      selectedRowIdInTable: contextValue.selectedRowIdInTable,
      exportBtnClicked: exportBtnClicked,
      setExportBtnClicked: setExportBtnClicked,
      setExportDetails: setExportDetails,
      setLoading: setLoading,
      setSpinnerLoad: setSpinnerLoad
    }

    if ((!saveBtnClicked && overlayName === '') || (saveTriggered && formData.name !== '') || (!saveBtnClicked && overlayName === 'editAutomation') || automationSearchVal.length > 0) {
      schedulerConfiguration(props);
    }
  }, [deleteAutomation, isRefresh, searchVal, saveTriggered, rowID, currentPageNo, automationSearchVal, /*formData,*/ isFilter, filterArray, exportBtnClicked]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
											{ name: "Automate", link: "/home" },
                      {name:"Automation", link:"/automate/automation/all_automations"},
                      {name:"Automation Scheduler", link:"#"}
                    ]}
                  /> </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            <Stack style={DynamicBoxingCSS}>
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal >
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomationPages("Automation Scheduler")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <StackItem>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn={
                                  <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                  <Divider />
                                  <MenuList>
                                    <Stack tokens={{ childrenGap: 5 }}>
                                      <StackItem> <Text></Text> </StackItem>
                                      <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                      <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                      <StackItem> <Divider /> </StackItem>
                                      <StackItem> <Caption1> Value </Caption1> </StackItem>
                                      {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Last Modified') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                      {(dropDownValue1 === "Name" || dropDownValue1 === "Description" || dropDownValue1 === "Status") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                      {dropDownValue1 === "Created By" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                      <StackItem> <Divider /> </StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem>
                                          <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                            disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                            <Caption1> Apply </Caption1>
                                          </Button>
                                        </StackItem>

                                        <StackItem>
                                          <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                            <Caption1> Cancel </Caption1>
                                          </Button>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                  </MenuList>
                                </>} />
                              </StackItem>

                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 && (
                                <Stack horizontal wrap>
                                  {filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                </Stack>
                              )}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                        <InfoBar showSpaces={true} title={"Automation Schedule is a solution that executes tasks at a predefined, scheduled time. To set up an automation schedule, the solution must be configured as either a Self-help or Proactive solution."} />

                      </StackItem>

                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} setOverlayOpen={setOverlayOpen} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>

            <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={automationOverLayData} saveBtnFunc={setSaveBtnClicked} saveBtnClicked={saveBtnClicked} isNavBtn={automationStatus !== 'not attached' ? false : true} handleOutsideButton={handleOutsideButton} handleSubmit={handleSubmit} classificationNameValidation={classificationNameValidation} />

            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={(!saveBtnClicked && overlayName === '') ? "Automation Deleted Successfully" : overlayName === 'addAutomation' ? "New Automation Created Successfully" : "Automation Edited Successfully"} footer="" />}

            {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

            {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};